module.exports = __webpack_public_path__ + "static/img/05.a87b5f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/05.jpg
// module id = mynj
// module chunks = 0